export const PAGINATION_DEFAULTS = {
  current: 1,
  pageSize: 20,
  showSizeChanger: true,
};

export const SORTER_DEFAULT = "id:desc";

export const FILTER_DEFAULTS = {};
